<div class="comments">
  <div class="comments__header">
    <div class="comments__header__title">
      <fa-icon [icon]="faComment"></fa-icon>
      <h2 class="fs__lg fw__600">Comments</h2>
    </div>

    @if (activeHashtag$()) {
      <empathy-comments-filter
        [allowFilterRemoval]="allowFilterRemoval()"
        [filterValue]="activeHashtag$()"
        (filter)="onSingleFilterComments($event)"
        (removeFilter)="onFilterComments('')"
      ></empathy-comments-filter>
    }

    <mat-button-toggle-group [formControl]="filterControl" aria-label="Filter pending and resolved comments" hideSingleSelectionIndicator>
      <mat-button-toggle [value]="false" [matBadge]="nonResolvedCommentsCount$()" [matBadgeHidden]="nonResolvedCommentsCount$() === 0">
        Pending
      </mat-button-toggle>
      <mat-button-toggle [value]="true" [matBadge]="resolvedCommentsCount$()" [matBadgeHidden]="resolvedCommentsCount$() === 0">Resolved</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="comments__list">
    @for (comment of filteredComments$(); track comment.id) {
      @if (comment.id === firstTodayCommentId$()) {
        <div class="comments__list__divider">
          <div class="line"><mat-divider></mat-divider></div>
          <div class="text fs__md">Today</div>
          <div class="line"><mat-divider></mat-divider></div>
        </div>
      }

      <empathy-comment
        [comment]="comment"
        [readonly]="readonly()"
        (emitHashtag)="onEmitHashtag($event)"
        (postComment)="onPostCommentReply($event)"
        (resolveThread)="onResolveThread(comment.id)"
        (saveChangesComment)="onSaveChanges($event)"
      ></empathy-comment>
    } @empty {
      <div class="comments__list__divider">
        <div class="line"><mat-divider></mat-divider></div>
        <div class="text fs__sm fw__500">No comments</div>
        <div class="line"><mat-divider></mat-divider></div>
      </div>
    }
  </div>
</div>
